import { ImportPlanRequest } from './../../domain/requests/plans/import-plan-request';
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../base";
import { PlansRepository } from "../../repositories";


@Injectable({ providedIn: 'root' })
export class ImportPlanUsecase implements UseCase<ImportPlanRequest,boolean> {

  constructor(private readonly planRepository: PlansRepository) {
  }

  execute(param?: ImportPlanRequest): Observable<boolean> {
    return this.planRepository.importPlan(param);
  }

}
